/** SVG football pitch – used as a decorative background element */
export default function FootballPitch({ style = {} }) {
  return (
    <svg
      viewBox="0 0 400 260"
      style={{ width: '100%', height: '100%', ...style }}
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="grass" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#0a2e14" />
          <stop offset="50%"  stopColor="#0d3a1a" />
          <stop offset="100%" stopColor="#0a2e14" />
        </linearGradient>
        <linearGradient id="stripe" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stopColor="#0d3a1a" stopOpacity="0" />
          <stop offset="50%"  stopColor="#11451e" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#0d3a1a" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Base */}
      <rect width="400" height="260" rx="4" fill="url(#grass)" />

      {/* Grass stripes */}
      {[0,1,2,3,4,5,6].map((i) => (
        <rect key={i} x={i * 57} y="0" width="28" height="260" fill="url(#stripe)" />
      ))}

      {/* Pitch outline */}
      <rect x="8" y="8" width="384" height="244" rx="2" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />

      {/* Centre line */}
      <line x1="200" y1="8" x2="200" y2="252" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" />

      {/* Centre circle */}
      <circle cx="200" cy="130" r="35" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />
      <circle cx="200" cy="130" r="2"  fill="rgba(255,255,255,0.5)" />

      {/* Left penalty box */}
      <rect x="8"  y="88"  width="52" height="84" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />
      <rect x="8"  y="108" width="26" height="44" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />

      {/* Right penalty box */}
      <rect x="340" y="88"  width="52" height="84" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />
      <rect x="366" y="108" width="26" height="44" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />

      {/* Penalty arcs */}
      <path d="M8 130 Q 25 115 42 130 Q 25 145 8 130"    stroke="rgba(255,255,255,0.18)" strokeWidth="1" fill="none" />
      <path d="M392 130 Q 375 115 358 130 Q 375 145 392 130" stroke="rgba(255,255,255,0.18)" strokeWidth="1" fill="none" />

      {/* Penalty spots */}
      <circle cx="60"  cy="130" r="2" fill="rgba(255,255,255,0.4)" />
      <circle cx="340" cy="130" r="2" fill="rgba(255,255,255,0.4)" />

      {/* Player dots (home = coral, away = white, accent = gold) */}
      {[
        [90,50,0],[160,70,1],[200,110,2],[250,90,0],[310,55,1],
        [80,180,2],[155,195,0],[205,160,1],[260,185,2],[320,175,0],
      ].map(([x,y,t], i) => (
        <circle key={i} cx={x} cy={y} r="4.5"
          fill={t===0 ? 'var(--coral)' : t===1 ? '#fff' : '#D4A847'}
          opacity="0.9"
        />
      ))}

      {/* Watermark */}
      <text x="200" y="242" textAnchor="middle" fill="rgba(255,255,255,0.1)" fontSize="9" fontFamily="Space Mono, monospace">hadafi.ae</text>
    </svg>
  );
}
